import {
  base_colorContentBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_family_weight_semibold,
  font_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * `ContentCard` ships spacing(9)/spacing(10) — sized for prose-ish panels. A
 * dense table reads as floating in it, so the vertical padding is trimmed and
 * the bottom dropped entirely: the grid's last row border is the panel's real
 * edge, and padding under it is the dead space this panel is meant to avoid.
 */
export const panel = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing(6)} ${spacing(8)} 0;
`

export const header = css`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${spacing(4)};
  margin-bottom: ${spacing(3)};
`

/**
 * Mirrors `cardDetailTabSectionTitle` (the Statements/Activity tab kicker) from
 * the same design spec. Duplicated rather than imported because that style lives
 * in `src/page-components/Accounts/` and a feature must not depend on a page.
 *
 * Uppercased via CSS, never in the translation source, so the accessible name
 * stays the plain phrase.
 */
export const title = css`
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_semibold};
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${text_colorTextSecondary};
  margin: 0;
`

/** Keeps the grid's own top border from doubling the card's inner spacing. */
export const grid = css`
  border-top: 1px solid ${base_colorContentBorder};
`

/**
 * Shared frame for the loading / empty / error bodies so the panel keeps a
 * stable height as it moves between them and the surrounding Overview sections
 * don't jump on load.
 */
export const statusBody = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: ${spacing(24)};
  margin: 0;
  /* The panel drops its bottom padding for the grid's flush last-row border;
     the status bodies have no such border and need it back. */
  padding-bottom: ${spacing(6)};
`
